import Swal from "sweetalert2";

export default function LoadingAlert(close) {
  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  Toast.fire({
    icon: "success",
    title: "Loading ...",
    timerProgressBar: true,
  });

  if (close) {
    Swal.close();
  }
}
